import React, { useEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getBoardById } from '../store/board/actions/board.actions';
import { utilService } from '../services/util.service';

export function ProtectedDesktopRoute({ children }) {
  const currentUser = useSelector((state) => state.auth?.currentUser);
  const accountTransition = useSelector((store) => store.auth?.accountTransition);
  const selectedDesktop = useSelector((state) => state.desktops?.selectedDesktop);
  const [board, setBoard] = useState(null);
  const { boardId } = useParams();

  const userId = currentUser?._id;

  useEffect(() => {
    if (!boardId) return;

    const fetch = async () => {
      try {
        const board = await getBoardById(boardId);
        setBoard(board);
      } catch (err) {
        console.error('Erro ao buscar board:', err);
        setBoard(null); // fallback seguro
      }
    };

    fetch();
  }, [boardId]);

  if (accountTransition) {
    return <div>Carregando...</div>;
  }

  //if (utilService.isAccountValid(account)) return <Navigate to="/home" replace />;

  if (currentUser?.userType === 0) return children;

  if (!userId) return <Navigate to="/home" replace />;

  const isAllowedInDesktop = selectedDesktop?.allowedUsers?.includes(userId);
  if (!isAllowedInDesktop) return <Navigate to="/home" replace />;

  // Espera carregar
  //if (boardId && (!board || board._id !== boardId)) return null;

  // Verifica se a board é restrita
  const boardIsRestricted = Array.isArray(board?.allowedUsers) && board.allowedUsers.length > 0;
  const userHasBoardAccess = board?.allowedUsers?.includes(userId);

  // Se for restrita e usuário não tem acesso → bloquear
  if (boardIsRestricted && !userHasBoardAccess) {
    return <Navigate to="/home" replace />;
  }

  return children;
}
